import MinusIcon from '@tagvenue/icons/24/bold/general/minus.svg?raw';
import PlusIcon from '@tagvenue/icons/24/bold/general/plus.svg?raw';

export const ZoomControlClasses = {
  ZoomControl: 'v-search-map__zoom',
  ZoomControlIn: 'v-search-map__zoom-in',
  ZoomControlOut: 'v-search-map__zoom-out',
};

export const getZoomControl = (googleMap) => {
  const controlDiv = document.createElement('div');
  const zoomin = document.createElement('button');
  const zoomout = document.createElement('button');
  controlDiv.classList.add(ZoomControlClasses.ZoomControl);
  controlDiv.classList.add('shadow-elevation-large');
  controlDiv.classList.add('hidden-xs');

  zoomin.classList.add(ZoomControlClasses.ZoomControlIn);
  zoomin.setAttribute('aria-label', 'Zoom in');

  zoomout.classList.add(ZoomControlClasses.ZoomControlOut);
  zoomout.setAttribute('aria-label', 'Zoom out');

  zoomin.innerHTML = PlusIcon;
  zoomout.innerHTML = MinusIcon;
  controlDiv.appendChild(zoomin);
  controlDiv.appendChild(zoomout);

  zoomout.addEventListener('click', () => {
    const currentZoomLevel = googleMap.getZoom();
    if (currentZoomLevel !== 0) {
      googleMap.setZoom(currentZoomLevel - 1);
    }
  });

  zoomin.addEventListener('click', () => {
    const currentZoomLevel = googleMap.getZoom();
    if (currentZoomLevel !== 21) {
      googleMap.setZoom(currentZoomLevel + 1);
    }
  });

  return controlDiv;
};
